export default "__VITE_ASSET__B7nD7Qtw__"